import { Injectable, Inject } from '@angular/core';
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { environment } from '@environments/environment'
import { catchError, mergeMap } from 'rxjs/operators';
import { ConfigurationServiceInterface } from '@interfaces/configuration-service.interface';
import { ADServiceInterface } from '@interfaces/ad-service.interface';
import { TableStorageServiceInterface } from '@interfaces/table-storage.interface';

@Injectable()
export class AdAuthorizationInterceptor<T> implements HttpInterceptor {

    constructor(
        @Inject('AdService') private adService: ADServiceInterface,
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //console.log(request.url)
        if (request.url == environment.graphApiToken) {
            return next.handle(request);
        }
        if (request.url.indexOf(environment.graphApiUrl) > -1 || request.url.indexOf(environment.apiUrl) > -1 || request.url.indexOf(environment.graphApiURL) > -1) {
            return this.getTokenConfig(false, next, request)
                .pipe(
                    catchError((error: HttpErrorResponse) => {
                        let status:string;
                        if(typeof(error)=="string"){
                            status = error;
                        }
                        if (status && (status.indexOf("401") > -1 || status.indexOf("403") > -1)) {
                            return this.getTokenConfig(true, next, request)
                        }
                        return throwError(error);
                    })
                )
        }
        return next.handle(request);
    }

    private getTokenConfig(isExpired: boolean, next: HttpHandler, request: HttpRequest<any>): Observable<HttpEvent<any>> {
        return this.adService
            .getToken$(isExpired)
            .pipe(
                mergeMap(token => next.handle(
                    this.addAuthenticationToken(token, request)
                )),
            )
    }
    private addAuthenticationToken(token: string, request: HttpRequest<any>): HttpRequest<any> {
        // TODO VALIDATE URL EXTERN API
        
        let username = "signature_manager";
        let password = "Eafit2021*";
        let authorizationData = 'Basic ' + btoa(username + ':' + password);
        if (request.url.indexOf(environment.graphApiURL) > -1) {
            authorizationData = `Bearer ${token}`;
        }
        if (request.url == environment.graphApiToken) {
            return request;
        }
        let url = request.url
        return request.clone({
            url,
            setHeaders: {
                ['Content-Type']: 'application/json;odata=nometadata',
                ['Accept']: 'application/json',
                ['Access-Control-Allow-Origin']: '*',
                ['Access-Control-Allow-Headers']: 'Authorization, X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Allow-Request-Method',
                ['Access-Control-Allow-Methods']: 'DELETE, POST, PUT, GET, OPTIONS',
                ['Allow']: 'GET, POST, OPTIONS, PUT, DELETE, X-API-KEY, Origin, X-Requested-With, Content-Type, Accept, Access-Control-Request-Method',
                ['Authorization']: authorizationData,
            }
        });
    }
}